<template>
    <template v-if="field">
        <span v-show="def.multi || !editing">
            <template v-for="(value,i) in field.value" :key="value">
                <audio>
                    <source :src="value" />
                    <p>Your user agent does not support the HTML5 Audio element.</p>
                </audio>
                <span class='value-audio'>{{$t("Play")}}</span>   
                <span v-if="def.user && editing" @click="remove(value)">&times;</span>
            </template>
        </span>
        <span v-if="def.user && !editing" class="edit" @click="startEdit" style="margin-left: 4px">
            <img src="/static/images/edit.png" alt="edit" />
        </span>
        <span v-if="editing">
            <span>Sorry, audio record not yet supported</span> 
            <!-- <input type="file" ref="image" class="form-control" @change="onImageChanged" accept=".jpg,.jpeg,.svg,.png,.gif" style="width:1px;height:1px;position:absolute;left:-10000px;">
            <img src="/static/images/add.svg" width="20" height="20" alt="load" @click="loadImage" /> -->
            <button @click="cancel">&times;</button>
        </span>
    </template>
</template>

<script>
import i18n from '@root/components/i18n';
import Api from '@root/components/api';

export default {
    props: ["field", "edit", "index"],
    emits: ["added", "removed", "saveImage"],
    mixins: [i18n],
    components: {},
    computed: {
        def() {
            return this.field?.def;
        },
        editing() {
            return this.def.user && (this.edit || this.localEdit);
        }
    },
    data() {
        return {
            newValue: '',
            localEdit: false,
        };
    },
    mounted() {
    },
    unmounted() {
    },
    methods: {
        startEdit() {
            this.localEdit = true;
            if (this.field.value.length == 0 || !this.def.multi) {
                this.$nextTick(()=>{
                    this.loadImage();
                });           
            }
        },
        remove(value) {
            this.$emit("removed", { value: value, def: this.def, values: this.field });
        },
        save() {
            this.$emit("added", { value: this.newValue, def: this.def, values: this.field });
            this.localEdit = false;
        },
        cancel() {
            this.localEdit = false;
        },
        loadImage() {
            this.$refs.image.click();
        },
        async onImageChanged(e) {
            let files = e.target.files;
            for(let i=0;i<files.length;++i) {
                const imageFile = files[i];
                this.$emit("saveImage", {file: imageFile, context: {def: this.def, values: this.field}});
                if (!this.def.multi) {
                    this.cancel();
                }
                // let response = await Api.saveImage(imageFile);
                // if (response.ok) {
                //     this.newValue = response.data;
                //     this.save();
                // }
                // console.log("Save image response", response);
            }
        },        
    }
}
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>

</style>

<i18n>
{
    en: {      
    },
    ru: {
        "Play": "Воспроизвести",
    }
}
</i18n>
